import React, { Component } from 'react';
import { Link } from 'react-router';
import FilterOrigine from './FilterOrigine';
import FilterInteret from './FilterInteret';
import FilterEtape from './FilterEtape';
import FilterSocieteSite from './FilterSocieteSite';
import FilterVendeur from './FilterVendeur';
import FilterType from './FilterType';
import FilterMarque from './FilterMarque';
import FilterBlock from '../Components/FilterBlock';
import FilterTypeClient from './FilterTypeClient';
import moment from "moment/moment";
import Dictionary from "../Dictionnary";
import {getCampaign} from "../Lib/MarketingCampaign";
var lodash = require('lodash');

class Sidebar extends Component {

  constructor(props) {
    super(props);

    this.state = {
      showFilters: false,
      currentLocation: '',
      currentHash: '#leads',
      campaigns: [],

      //Les cases pré-cochées car paramètres de filtrages définis dans l'url
      queryFilters: {
        "sites":[],
        "etapes":[],
        "interets":[],
        "origines":[],
        "vendeurs":[],
        "types": [],
        "marques":[],
        "typesClient":[],
      }
    }
  }

  componentDidMount() {
    if (window.location.hash === "#campaigns") {
      window.location.hash = "";
    }
  }

  handleTooltipEnter = (e, index) => {
    const rect = e.currentTarget.getBoundingClientRect();
    this.setState({
      activeTooltip: index,
      tooltipStyle: {
        visibility: 'visible',
        opacity: 1,
        position: 'fixed',
        top: `200px`,
        left: `${rect.right + 10}px`,
      }
    });
  };

  handleTooltipLeave = () => {
    this.setState({ activeTooltip: null, tooltipStyle: {} });
  };

  async componentDidUpdate(prevProps, prevState){
    var currentLocation = window.location.pathname;
    let currentHash = window.location.hash;

    if (
        prevProps.leads !== this.props.leads
    ) {
      let campaigns =
          lodash.uniqBy(
              this.props.leads
                  .filter((l) => l.CampagneMarketing && l.CampagneMarketing.IDCampagneMarketing)
                  .map((l) => l.CampagneMarketing),
              'IDCampagneMarketing'
          )

     /* const campaignsWithDetails = await Promise.all(
          campaigns.map(async (campaign) => {
            const campaignDetails = await getCampaign(campaign.IDCampagneMarketing);
            return { ...campaign, ...campaignDetails };
          })
      );*/

      this.setState({
        campaigns: campaigns
      });
    }


    if(currentHash !== this.state.currentHash) {
      this.setState({
        currentHash: currentHash,
        showFilters: true,
      });
    }

    if(currentLocation !== this.state.currentLocation) {
      var initFilters = [];

      if(this.props.queryFilters){
        var queryFilters = this.props.queryFilters;
        for(var type in this.state.queryFilters){
          if(!queryFilters[type] || queryFilters[type] == "") {
            initFilters[type] = [];
            continue;
          }

          if(type == 'sites')
            initFilters[type] = lodash.map(queryFilters[type].split(","), (f) => {return parseInt(f);});
          else
            initFilters[type] = queryFilters[type].split(",");
        }
      }

      this.setState({
        queryFilters: initFilters,
        showFilters: true,
        currentLocation: currentLocation,
      });
    }
  }

  onClick(event) {
    if (event.target.href === window.location.href) {
      this.setState({ showFilters: !this.state.showFilters });
    }
  }

  render() {

    return (
        <div  className="container-fluid">
          <div className="row">
            <div className="col-md-12">

              <Link to={'/leads/LeadsARedistribuer'} className={"btn btn-default linkToList " + (this.state.showFilters ? 'withFilters' : '')} activeClassName="active" onClick={this.onClick.bind(this)}>
                Leads à traiter <span></span>
              </Link>

              {this.state.currentLocation === '/leads/LeadsARedistribuer' && this.state.showFilters ?
                  window.location.hash === "#campaigns" || window.location.hash === null ?
                      <div>
                        <ul>
                          {this.state.campaigns && this.state.campaigns.length ?
                              this.state.campaigns.map((campaign, i) => {
                                  return (
                                      <div className="checkbox" key={campaign ? campaign.IDCampagneMarketing : null}>
                                        <input
                                            type="checkbox"
                                            name={campaign.Nom}
                                            id={campaign.IDCampagneMarketing}
                                            checked={this.props.selectedCampaigns && this.props.selectedCampaigns.includes(campaign.Nom)}
                                            onChange={(e) => this.props.onSelectCampaign(campaign.Nom, e)}
                                            value={campaign.Nom}
                                        />
                                        <label className="label-box" htmlFor={i}>
                                          {campaign.Nom}
                                        </label>

                                        <div
                                            onMouseEnter={(e) => this.handleTooltipEnter(e, i)}
                                            onMouseLeave={this.handleTooltipLeave}
                                            className="tooltip-test" style={{ marginLeft: '10px', cursor: 'pointer' }}>
                                          <i
                                              className="fa fa-eye"
                                          />

                                          <div
                                              style={this.state.activeTooltip === i ? this.state.tooltipStyle : { visibility: 'hidden', opacity: 0 }}
                                              className="tooltip-text">
                                            <p>{campaign.Nom ? campaign.Nom : "" }</p>
                                            <p>{(campaign.IDLead ? campaign.IDLead : "") + ' - ' + (campaign.Objectif ? campaign.Objectif : "")}</p>
                                            <br/>
                                            <p>Dates: {campaign.start_date ? moment(campaign.start_date).format('DD/MM/YYYY') : "" + " - "
                                            + campaign.end_date ? moment(campaign.end_date).format('DD/MM/YYYY') : ""}</p>
                                            <p>Jours ouvrés: {campaign.business_days_count ? campaign.business_days_count : "" }</p>
                                            {campaign.EstReccurente &&
                                                <p>Fréquence: {campaign.frequency ? campaign.frequency : "" }</p>
                                            }
                                            <br/>
                                            <p>Cible totale: {campaign.total_targets_count ? campaign.total_targets_count : "" }</p>
                                            <p>Segmentation: {campaign.segmentation ? campaign.segmentation : "" }</p>
                                            <br/>
                                            <p>Objectifs: {campaign.Objectif ? campaign.Objectif : ""}</p>
                                            <p>Principe/argument: {campaign.Sujet ? campaign.Sujet : ""}</p>
                                          </div>

                                        </div>

                                        <div className='clearfix' />
                                      </div>
                                  );
                              })
                              : <li>Aucune campagne marketing associée</li>
                          }
                        </ul>
                      </div> :
                      <div>
                        <FilterBlock className="filter-block-sidebar-leads" title="Société / Site" isOpen={this.state.queryFilters["sites"].length > 0}>
                          <FilterSocieteSite leads={this.props.leads} onChange={this.props.onChangeFilters} selected={this.state.queryFilters['sites']} />
                        </FilterBlock>
                        <FilterBlock className="filter-block-sidebar-leads" title="Origine" isOpen={this.state.queryFilters["origines"].length > 0}>
                          <FilterOrigine type={this.props.type} leads={this.props.leads} onChange={this.props.onChangeFilters} selected={this.state.queryFilters['origines']}/>
                        </FilterBlock>
                        <FilterBlock className="filter-block-sidebar-leads" title="Type" isOpen={this.state.queryFilters["types"].length > 0}>
                          <FilterType typeAffichage={this.props.type} leads={this.props.leads} onChange={this.props.onChangeFilters} selected={this.state.queryFilters['types']}/>
                        </FilterBlock>
                        <FilterBlock className="filter-block-sidebar-leads" title="Marque" isOpen={this.state.queryFilters["marques"].length > 0}>
                          <FilterMarque marques={this.props.marques} onChange={this.props.onChangeFilters} selected={this.state.queryFilters['marques']}/>
                        </FilterBlock>
                      </div>
                  : null}



              {localStorage.user_profil === 'BDC' ?
                  <div>
                    <br/>
                    <br/>

                    <Link to={'/leads/AffairesEncoursBDC'} className={"btn btn-orange linkToList " + (this.state.showFilters ? 'withFilters' : '')} activeClassName="active" onClick={this.onClick.bind(this)}>
                      Leads en cours de traitement <span></span>
                    </Link>

                    {this.state.currentLocation === '/leads/AffairesEncoursBDC' && this.state.showFilters ?
                        <div>
                          <FilterBlock className="filter-block-sidebar-leads" title="Étape" isOpen={this.state.queryFilters["etapes"].length > 0}>
                            <FilterEtape etapes={this.props.etapes} onChange={this.props.onChangeFilters} selected={this.state.queryFilters['etapes']} />
                          </FilterBlock>
                          <FilterBlock className="filter-block-sidebar-leads" title="Intérêt" isOpen={this.state.queryFilters["interets"].length > 0}>
                            <FilterInteret interets={this.props.interets} onChange={this.props.onChangeFilters} selected={this.state.queryFilters['interets']} />
                          </FilterBlock>
                          <FilterBlock className="filter-block-sidebar-leads" title="Origine" isOpen={this.state.queryFilters["origines"].length > 0}>
                            <FilterOrigine type={this.props.type} leads={this.props.leads} onChange={this.props.onChangeFilters} selected={this.state.queryFilters['origines']}/>
                          </FilterBlock>
                          <FilterBlock className="filter-block-sidebar-leads" title="Société / Site" isOpen={this.state.queryFilters["sites"].length > 0}>
                            <FilterSocieteSite leads={this.props.leads} onChange={this.props.onChangeFilters} selected={this.state.queryFilters['sites']}/>
                          </FilterBlock>
                          <FilterBlock className="filter-block-sidebar-leads" title="Vendeur" isOpen={this.state.queryFilters["vendeurs"].length > 0}>
                            <FilterVendeur vendeurs={this.props.vendeurs} onChange={this.props.onChangeFilters} selected={this.state.queryFilters['vendeurs']}/>
                          </FilterBlock>
                          <FilterBlock className="filter-block-sidebar-leads" title="Type" isOpen={this.state.queryFilters["types"].length > 0}>
                            <FilterType typeAffichage={this.props.type} leads={this.props.leads} onChange={this.props.onChangeFilters} selected={this.state.queryFilters['types']}/>
                          </FilterBlock>
                          <FilterBlock className="filter-block-sidebar-leads" title="Marque" isOpen={this.state.queryFilters["marques"].length > 0}>
                            <FilterMarque marques={this.props.marques} onChange={this.props.onChangeFilters} selected={this.state.queryFilters['marques']}/>
                          </FilterBlock>
                          <FilterBlock className="filter-block-sidebar-leads" title="Catégorie client" isOpen={this.state.queryFilters["typesClient"].length > 0}>
                            <FilterTypeClient leads={this.props.leads} onChange={this.props.onChangeFilters} selected={this.state.queryFilters['typesClient']}/>
                          </FilterBlock>
                        </div>
                        : null}
                  </div>

                  : null}

              <br/><br/>

              <Link to={'/leads/AffairesEncoursVendeur'} className={"btn btn-warning linkToList " + (this.state.showFilters ? 'withFilters' : '')} activeClassName="active" onClick={this.onClick.bind(this)}>
                Affaires en cours <span></span>
              </Link>

              {this.state.currentLocation === '/leads/AffairesEncoursVendeur' && this.state.showFilters ?
                  <div>
                    <FilterBlock className="filter-block-sidebar-leads" title="Étape" isOpen={this.state.queryFilters["etapes"].length > 0}>
                      <FilterEtape etapes={this.props.etapes} onChange={this.props.onChangeFilters} selected={this.state.queryFilters['etapes']}/>
                    </FilterBlock>
                    <FilterBlock className="filter-block-sidebar-leads" title="Niveau d'intérêt" isOpen={this.state.queryFilters["interets"].length > 0}>
                      <FilterInteret interets={this.props.interets} onChange={this.props.onChangeFilters} selected={this.state.queryFilters['interets']}/>
                    </FilterBlock>
                    <FilterBlock className="filter-block-sidebar-leads" title="Origine" isOpen={this.state.queryFilters["origines"].length > 0}>
                      <FilterOrigine type={this.props.type} leads={this.props.leads} onChange={this.props.onChangeFilters} selected={this.state.queryFilters['origines']}/>
                    </FilterBlock>
                    <FilterBlock className="filter-block-sidebar-leads" title="Société / Site" isOpen={this.state.queryFilters["sites"].length > 0}>
                      <FilterSocieteSite leads={this.props.leads} onChange={this.props.onChangeFilters} selected={this.state.queryFilters['sites']}/>
                    </FilterBlock>
                    <FilterBlock className="filter-block-sidebar-leads" title="Vendeur" isOpen={this.state.queryFilters["vendeurs"].length > 0}>
                      <FilterVendeur vendeurs={this.props.vendeurs} onChange={this.props.onChangeFilters} selected={this.state.queryFilters['vendeurs']}/>
                    </FilterBlock>
                    <FilterBlock className="filter-block-sidebar-leads" title="Type" isOpen={this.state.queryFilters["types"].length > 0}>
                      <FilterType typeAffichage={this.props.type} leads={this.props.leads} onChange={this.props.onChangeFilters} selected={this.state.queryFilters['types']}/>
                    </FilterBlock>
                    <FilterBlock className="filter-block-sidebar-leads" title="Marque" isOpen={this.state.queryFilters["marques"].length > 0}>
                      <FilterMarque marques={this.props.marques} onChange={this.props.onChangeFilters} selected={this.state.queryFilters['marques']}/>
                    </FilterBlock>
                    <FilterBlock className="filter-block-sidebar-leads" title="Catégorie client" isOpen={this.state.queryFilters["typesClient"].length > 0}>
                      <FilterTypeClient leads={this.props.leads} onChange={this.props.onChangeFilters} selected={this.state.queryFilters['typesClient']}/>
                    </FilterBlock>
                  </div>
                  : null}

              <br /><br />

              <Link to={'/leads/AffairesGagnees'} className={"btn btn-success linkToList " + (this.state.showFilters ? 'withFilters' : '')} activeClassName="active" onClick={this.onClick.bind(this)}>
                Gagnés <span></span>
              </Link>

              {this.state.currentLocation === '/leads/AffairesGagnees' && this.state.showFilters ?
                  <div>
                    <FilterBlock className="filter-block-sidebar-leads" title="Origine" isOpen={this.state.queryFilters["origines"].length > 0}>
                      <FilterOrigine type={this.props.type} leads={this.props.leads} onChange={this.props.onChangeFilters} selected={this.state.queryFilters['origines']}/>
                    </FilterBlock>
                    <FilterBlock className="filter-block-sidebar-leads" title="Société / Site" isOpen={this.state.queryFilters["sites"].length > 0}>
                      <FilterSocieteSite leads={this.props.leads} onChange={this.props.onChangeFilters} selected={this.state.queryFilters['sites']}/>
                    </FilterBlock>
                    <FilterBlock className="filter-block-sidebar-leads" title="Vendeur" isOpen={this.state.queryFilters["vendeurs"].length > 0}>
                      <FilterVendeur vendeurs={this.props.vendeurs} onChange={this.props.onChangeFilters} selected={this.state.queryFilters['vendeurs']}/>
                    </FilterBlock>
                    <FilterBlock className="filter-block-sidebar-leads" title="Type" isOpen={this.state.queryFilters["types"].length > 0}>
                      <FilterType typeAffichage={this.props.type} leads={this.props.leads} onChange={this.props.onChangeFilters} selected={this.state.queryFilters['types']}/>
                    </FilterBlock>
                    <FilterBlock className="filter-block-sidebar-leads" title="Catégorie client" isOpen={this.state.queryFilters["typesClient"].length > 0}>
                      <FilterTypeClient leads={this.props.leads} onChange={this.props.onChangeFilters} selected={this.state.queryFilters['typesClient']}/>
                    </FilterBlock>
                  </div>
                  : null}

              <br /><br />

              <Link to={'/leads/AffairesClotures'} className={"btn btn-danger linkToList " + (this.state.showFilters ? 'withFilters' : '')} activeClassName="active" onClick={this.onClick.bind(this)}>
                Clôturés <span></span>
              </Link>

              {this.state.currentLocation === '/leads/AffairesClotures' && this.state.showFilters ?
                  <div>
                    <FilterBlock className="filter-block-sidebar-leads" title="Origine" isOpen={this.state.queryFilters["origines"].length > 0}>
                      <FilterOrigine type={this.props.type} leads={this.props.leads} onChange={this.props.onChangeFilters} selected={this.state.queryFilters['origines']}/>
                    </FilterBlock>
                    <FilterBlock className="filter-block-sidebar-leads" title="Société / Site" isOpen={this.state.queryFilters["sites"].length > 0}>
                      <FilterSocieteSite leads={this.props.leads} onChange={this.props.onChangeFilters} selected={this.state.queryFilters['sites']}/>
                    </FilterBlock>
                    <FilterBlock className="filter-block-sidebar-leads" title="Vendeur" isOpen={this.state.queryFilters["vendeurs"].length > 0}>
                      <FilterVendeur vendeurs={this.props.vendeurs} onChange={this.props.onChangeFilters} selected={this.state.queryFilters['vendeurs']}/>
                    </FilterBlock>
                    <FilterBlock className="filter-block-sidebar-leads" title="Type" isOpen={this.state.queryFilters["types"].length > 0}>
                      <FilterType typeAffichage={this.props.type} leads={this.props.leads} onChange={this.props.onChangeFilters} selected={this.state.queryFilters['types']}/>
                    </FilterBlock>
                    <FilterBlock className="filter-block-sidebar-leads" title="Catégorie client" isOpen={this.state.queryFilters["typesClient"].length > 0}>
                      <FilterTypeClient leads={this.props.leads} onChange={this.props.onChangeFilters} selected={this.state.queryFilters['typesClient']}/>
                    </FilterBlock>
                  </div>
                  : null}

            </div>
          </div>
        </div>
    );
  }
}

export default Sidebar;
